module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "h3"
  }, [_vm._v("Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Here is where you can review procedures submitted by patients.")]), _vm._v(" "), _c('module-button', {
    staticClass: "mt0 mb",
    attrs: {
      "button": "primary",
      "size": "m",
      "label": "Start Reviewing"
    },
    nativeOn: {
      "click": function($event) {
        _vm.startReviewing($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e27b00c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/Reviews.vue
// module id = 341
// module chunks = 0